module.exports = __webpack_public_path__ + "static/media/Circe-Bold.208f1642.otf";